import {ADD_LANGUAGE, SET_LANGUAGE, SET_LANGUAGE_LIST} from '../mutation-types'
import {GET_LANGUAGE_DETAILS, GET_LANGUAGE_DETAILS_PER_LOCALE} from '../action-types'
import axios from 'axios'
import Vue from 'vue'

const state = {
  languages: [],
  languagesList: []

}

const getters = {
  getLanguageFromDescription: (state) => (description) => {
    let languageDescription = ''
    state.languages.forEach((language) => {
      languageDescription = language.description === description ? language.name : languageDescription
    })
    return languageDescription
  },
  getLanguageDescriptions: (state) => {
    return state.languagesList.filter(language => (language.visible)).map(x => x.description)
  }
}

const mutations = {
  [ADD_LANGUAGE] (state, language) {
    state.languages.push(language)
  },
  [SET_LANGUAGE] (state, languages) {
    state.languages = languages
  },
  [SET_LANGUAGE_LIST] (state, languagesList) {
    state.languagesList = languagesList
  }
}

const actions = {
  [GET_LANGUAGE_DETAILS] ({rootState, commit, dispatch}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/translation/language`,
      method: 'get',
      headers: {
        'Authorization': rootState.config.accessToken
      },
      actionData: {action: GET_LANGUAGE_DETAILS}
    })
      .then((res) => {
        commit(SET_LANGUAGE_LIST, res.data)
        Vue.i18n.set(state.languagesList[1].name)
        for (let language of state.languagesList) {
          commit(ADD_LANGUAGE, language)
          dispatch(GET_LANGUAGE_DETAILS_PER_LOCALE, language.name)
        }
        Vue.i18n.fallback(state.languagesList[0].name)
      })
      .catch((err) => {
        console.log(`Errored while trying to fetch language from core`)
        console.error(err)
      })
  },
  [GET_LANGUAGE_DETAILS_PER_LOCALE] ({rootState, commit}, languageName) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/translation/language/${languageName}`,
      method: 'get',
      headers: {
        'Authorization': rootState.config.accessToken
      },
      actionData: {action: GET_LANGUAGE_DETAILS_PER_LOCALE}
    })
      .then((res) => {
        Vue.i18n.add(languageName, res.data)
      })
      .catch((err) => {
        console.log(`Errored while trying to fetch language specific for locale from core`)
        console.error(err)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js